var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeaderUd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 58,
    viewBox: "0 0 64 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 53306"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M64 0.956055V22.9756L0 48.9939L64 0.956055Z",
    fill: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M52.0019 0V37.9851C52.0019 43.2933 49.8946 48.3842 46.1437 52.1377C42.3927 55.8913 37.3053 58 32.0006 58C26.696 58 21.6086 55.8913 17.8576 52.1377C14.1067 48.3842 11.9994 43.2933 11.9994 37.9851V21.9792L23.9981 15.3713V37.9851C23.8858 38.972 23.9831 39.9715 24.2836 40.9183C24.5842 41.865 25.0811 42.7374 25.7422 43.4784C26.4032 44.2195 27.2131 44.8124 28.119 45.2184C29.025 45.6244 30.0064 45.8344 30.9991 45.8344C31.9917 45.8344 32.9732 45.6244 33.8791 45.2184C34.7849 44.8124 35.595 44.2195 36.2559 43.4784C36.9169 42.7374 37.414 41.865 37.7145 40.9183C38.0151 39.9715 38.1124 38.972 38 37.9851V7.6655L52.0019 0Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderUd);
export default __webpack_public_path__ + "static/media/header-ud.abfa57d457fa5bc641f81a2800a9ba05.svg";
export { ForwardRef as ReactComponent };